import axios, { AxiosRequestConfig, AxiosResponse, AxiosError } from "axios";
import { LoginResponse } from "../api/interfaces";

class AuthService {
  static login<Response = LoginResponse>(
    username: string,
    password: string
  ): Promise<AxiosResponse<Response>> {
    const formData = new FormData();
    formData.append("username", username);
    formData.append("password", password);

    const config: AxiosRequestConfig<FormData> = {
      method: "post",
      url: "https://clients.wearegenial.com/api/v1/auth/login",
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };

    return new Promise<AxiosResponse<Response>>((resolve, reject) => {
      axios(config)
        .then((response: AxiosResponse<Response>) => {
          resolve(response);
        })
        .catch((error: AxiosError) => {
          reject(error);
        });
    });
  }
}

export default AuthService;
